export default {
  GET_VESTING_INFO: 'GET_VESTING_INFO',
  CLAIM_TOKENS: 'CLAIM_TOKENS',
} as const;
